/**
 * PHOTOBOOTH LAYOUT & THEME CONFIG
 * Centralized config — edit here to customize everything
 */

// ─── LAYOUTS ────────────────────────────────────────────────────────────────
export const LAYOUTS = [
  {
    id: 'solo',
    label: 'Solo',
    icon: '□',
    slots: 1,
    cols: 1,
    rows: 1,
    frameAspect: '3/4',   // overall frame aspect ratio
    slotAspect: '4/3',    // each photo slot aspect ratio
  },
  {
    id: 'strip2',
    label: 'Strip 2',
    icon: '▭▭',
    slots: 2,
    cols: 1,
    rows: 2,
    frameAspect: '3/8',
    slotAspect: '4/3',
  },
  {
    id: 'strip3',
    label: 'Strip 3',
    icon: '▭▭▭',
    slots: 3,
    cols: 1,
    rows: 3,
    frameAspect: '1/3',
    slotAspect: '4/3',
  },
  {
    id: 'strip4',
    label: 'Strip 4',
    icon: '||||',
    slots: 4,
    cols: 1,
    rows: 4,
    frameAspect: '1/4',
    slotAspect: '4/3',
  },
  {
    id: 'grid4',
    label: 'Grid 4',
    icon: '⊞',
    slots: 4,
    cols: 2,
    rows: 2,
    frameAspect: '3/4',
    slotAspect: '4/3',
  },
  {
    id: 'grid6',
    label: 'Grid 6',
    icon: '⊟',
    slots: 6,
    cols: 2,
    rows: 3,
    frameAspect: '2/3',
    slotAspect: '4/3',
  },
];

// ─── FILTERS ─────────────────────────────────────────────────────────────────
export const FILTERS = [
  { id: 'normal',  label: 'Normal',  css: 'none' },
  { id: 'bw',      label: 'B&W',     css: 'grayscale(100%) contrast(1.1)' },
  { id: 'sepia',   label: 'Vintage', css: 'sepia(80%) contrast(1.05) brightness(0.96)' },
  { id: 'vivid',   label: 'Vivid',   css: 'saturate(1.8) contrast(1.1)' },
  { id: 'warm',    label: 'Warm',    css: 'sepia(25%) saturate(1.4) brightness(1.05)' },
  { id: 'cool',    label: 'Cool',    css: 'hue-rotate(25deg) saturate(1.2) brightness(1.05)' },
  { id: 'faded',   label: 'Faded',   css: 'contrast(0.8) brightness(1.15) saturate(0.6)' },
  { id: 'noir',    label: 'Noir',    css: 'grayscale(100%) contrast(1.4) brightness(0.85)' },
];

// ─── THEMES ──────────────────────────────────────────────────────────────────
export const THEMES = [
  {
    id: 'film',
    label: 'Film Strip',
    icon: '🎞️',
    description: 'Classic analog film',
    frame: {
      background: '#111008',
      padding: '0',
      borderRadius: '0',
      boxShadow: 'none',
    },
    slots: {
      gap: '3px',
      padding: '0 40px',
      paddingTop: '48px',
      paddingBottom: '40px',
    },
    header: {
      background: '#111008',
      color: '#F0E4D0',
      fontFamily: "'DM Mono', monospace",
      fontSize: '11px',
      letterSpacing: '0.2em',
      textTransform: 'uppercase',
      padding: '12px 40px',
      text: '✦ HAPPY BIRTHDAY, NOF ✦',
    },
    footer: {
      background: '#111008',
      color: 'rgba(240,228,208,0.45)',
      fontFamily: "'DM Mono', monospace",
      fontSize: '10px',
      letterSpacing: '0.15em',
      padding: '10px 40px',
      text: '05.05.2026  ·  from your husband  ·  ♡',
    },
    sideDecoration: {
      show: true,
      width: 40,
      background: '#111008',
      perforationColor: '#2a2a1a',
    },
  },
  {
    id: 'polaroid',
    label: 'Polaroid',
    icon: '📷',
    description: 'White classic frame',
    frame: {
      background: '#FAF7F2',
      padding: '0',
      borderRadius: '2px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
    },
    slots: {
      gap: '12px',
      padding: '16px 16px 8px',
    },
    header: {
      background: 'transparent',
      color: '#5C4A36',
      fontFamily: "'Playfair Display', serif",
      fontSize: '14px',
      fontStyle: 'italic',
      padding: '8px 16px 0',
      text: 'Happy Birthday, Nof 🌹',
    },
    footer: {
      background: 'transparent',
      color: '#9A8070',
      fontFamily: "'DM Mono', monospace",
      fontSize: '10px',
      letterSpacing: '0.1em',
      padding: '8px 16px 16px',
      text: '05 · 05 · 2026',
    },
  },
  {
    id: 'aesthetic',
    label: 'Aesthetic',
    icon: '🌿',
    description: 'Warm earthy tones',
    frame: {
      background: '#1C1208',
      padding: '12px',
      border: '2px solid rgba(193,123,90,0.4)',
      borderRadius: '4px',
      boxShadow: '0 0 0 1px rgba(193,123,90,0.15), 0 8px 30px rgba(0,0,0,0.5)',
    },
    slots: {
      gap: '4px',
      padding: '0',
    },
    header: {
      background: 'transparent',
      color: '#D4A863',
      fontFamily: "'Playfair Display', serif",
      fontSize: '14px',
      fontStyle: 'italic',
      letterSpacing: '0.02em',
      padding: '8px 4px',
      text: '✦ Nof ✦',
    },
    footer: {
      background: 'transparent',
      color: 'rgba(212,168,99,0.5)',
      fontFamily: "'DM Mono', monospace",
      fontSize: '9px',
      letterSpacing: '0.2em',
      textTransform: 'uppercase',
      padding: '8px 4px',
      text: 'with love · 05.05.2026',
    },
  },
  {
    id: 'y2k',
    label: 'Y2K',
    icon: '✨',
    description: 'Bold neon chrome',
    frame: {
      background: 'linear-gradient(135deg, #0d0020 0%, #1a0035 50%, #0d0020 100%)',
      padding: '3px',
      borderRadius: '8px',
      border: '3px solid transparent',
      backgroundClip: 'padding-box',
      boxShadow: '0 0 30px rgba(167,139,250,0.3)',
    },
    slots: {
      gap: '3px',
      padding: '8px',
    },
    header: {
      background: 'transparent',
      color: '#FDE68A',
      fontFamily: "'DM Sans', sans-serif",
      fontSize: '13px',
      fontWeight: '700',
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      padding: '8px',
      text: '☆ HAPPY BIRTHDAY NOF ☆',
      textShadow: '0 0 10px rgba(253,230,138,0.5)',
    },
    footer: {
      background: 'transparent',
      color: '#A78BFA',
      fontFamily: "'DM Mono', monospace",
      fontSize: '10px',
      letterSpacing: '0.15em',
      padding: '8px',
      text: '✧ 05.05.2026 ✧',
      textShadow: '0 0 8px rgba(167,139,250,0.5)',
    },
  },
  {
    id: 'korean',
    label: 'Korean Cafe',
    icon: '🌸',
    description: 'Soft pink cafe style',
    frame: {
      background: '#FFF5F7',
      padding: '0',
      borderRadius: '3px',
      border: '12px solid #FFF5F7',
      boxShadow: '0 4px 20px rgba(196,132,122,0.2)',
    },
    slots: {
      gap: '6px',
      padding: '6px',
    },
    header: {
      background: 'transparent',
      color: '#C4847A',
      fontFamily: "'Playfair Display', serif",
      fontSize: '13px',
      fontStyle: 'italic',
      padding: '4px 8px',
      text: '생일 축하해요, Nof! 🎂',
    },
    footer: {
      background: 'transparent',
      color: '#C4ADA8',
      fontFamily: "'DM Mono', monospace",
      fontSize: '9px',
      letterSpacing: '0.1em',
      padding: '4px 8px',
      text: '05 · 05 · 2026  🌸',
    },
  },
  {
    id: 'minimal',
    label: 'Minimal',
    icon: '◻',
    description: 'Clean & modern',
    frame: {
      background: '#0E0C0A',
      padding: '2px',
      border: '1px solid rgba(240,228,208,0.15)',
      borderRadius: '2px',
    },
    slots: {
      gap: '2px',
      padding: '16px',
    },
    header: {
      background: 'transparent',
      color: 'rgba(240,228,208,0.45)',
      fontFamily: "'DM Mono', monospace",
      fontSize: '9px',
      letterSpacing: '0.25em',
      textTransform: 'uppercase',
      padding: '10px 16px 4px',
      text: 'Nof  ·  05.05.2026',
    },
    footer: {
      background: 'transparent',
      color: 'rgba(240,228,208,0.2)',
      fontFamily: "'DM Mono', monospace",
      fontSize: '8px',
      letterSpacing: '0.2em',
      padding: '4px 16px 12px',
      text: 'with love',
    },
  },
];
